interface CreateMarkProps {
  text: string
  color: string
  dataType: string
  dataAttributes?: Record<string, string | null | undefined>
}

export const createMark = ({
  text,
  color,
  dataType,
  dataAttributes,
}: CreateMarkProps) => {
  // Persist optional data-* attributes (for example data-toolid) on inserted pills.
  const renderedDataAttributes = Object.entries(dataAttributes || {})
    .filter(([, value]) => typeof value === 'string' && value.trim() !== '')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ')

  const attributes = renderedDataAttributes ? ` ${renderedDataAttributes}` : ''

  return `<mark class="slash-command-pill" data-type="${dataType}"${attributes} style="background-color: ${color};color: rgb(30, 30, 30);">${text}</mark> `
}
